const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-file/collector.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { CollectorListFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-file/collector-list-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-file/collector')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: CollectorListFilterParamSchema
});